<template>
  <h1>New Provider</h1>
</template>

<script>
export default {};
</script>

<style></style>
